module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errorText":"There were connection troubles. Trying to reconnect... Check your internet connection.","safariChangeMic":"You have connected new device. Setup started..."}}')
  delete Component.options._Ctor
}
